import "./css/hero.css";
import HeroLeft from "./HeroLeft";
import HeroRight from "./HeroRight";

const HeroBanner = () => {
  return (
    <section className="hero-container d-flex align-items-center">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-12 mb-4 mb-lg-0">
            <HeroLeft />
          </div>

          <div className="col-lg-6 col-12 text-center text-lg-start">
            <HeroRight />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;
